<form
    [formGroup]="contactDetailsForm()"
    novalidate
    class="ap-personal-details ap-grid ap-grid-cols-1 ap-grid-cols-gt-md-2 ap-gap-2 ap-gap-gt-md-5 ap-grid-margin-fix"
>
    @if (contactDetailsForm().controls.emailAddress) {
        <ap-email-input
            formControlName="emailAddress"
            autocomplete="email"
            [messages]="errorMessagesEmail"
            [label]="'contact.details.emailAddress.label' | apKeyOverride: contentKeyMap() | apContent"
            data-testid="email"
        ></ap-email-input>
    }
    @if (contactDetailsForm().controls.phoneNumber) {
        <ap-phone-input
            formControlName="phoneNumber"
            [numberFormat]="numberFormat()"
            autocomplete="tel"
            [messages]="errorMessagesPhone"
            [label]="'contact.details.phoneNumber.label' | apKeyOverride: contentKeyMap() | apContent"
            data-testid="phone"
        ></ap-phone-input>
    }
</form>
